import React from "react";
import { useVideoStore } from "./store/use-videos-store";
import { Grid, Paper } from "@mui/material";
import imageBg from "../../../../images/bg-equipments.jpg";
import { COLOR_PRIMARY, NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import { Alert, Input, Segmented } from "antd";
import SweetAlert from "sweetalert2";
import VideoCajas from "./video-cajas";
import VideoCierreContenedor from "./video-cierre-contenedor";
import VideoCajasRecorder from "./video-cajas-recorder"; // ✅ Importar componente separado
import VideoCierreRecorder from "./video-cierre-recorder"; // ✅ Importar componente separado

const VideoPageComponent = () => {
  return (
    <Grid
      container
      spacing={1}
      justifyContent="center"
      sx={{
        mt: 0,
        maxHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        height: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        overflowY: "hidden",
        overflowX: "hidden",
        backgroundImage: `url(${imageBg})`,
      }}
    >
      <Grid item xs={12} sm={6} md={5}>
        <Paper elevation={2} sx={{ m: 1, position: "relative" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Component />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

const Component = () => {
  const container = useVideoStore((state) => state.container);
  const [value, setValue] = React.useState<string | number>("Seleccionar");

  const handleChangeValue = (elValue: any) => {
    SweetAlert.fire({
      title: `Si cambia de opción, se borrará el video ${
        value === "Grabar" ? "grabado" : "seleccionado"
      }`,
      icon: "warning",
      confirmButtonColor: COLOR_PRIMARY,
      confirmButtonText: `${
        value === "Seleccionar" ? "Ir a Grabar" : "Ir a Seleccionar"
      }`,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setValue(elValue);
      }
    });
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={1}
      sx={{
        minHeight: "350px",
        mt: 1,
        maxHeight: "calc(100vh - 140px)",
        overflowY: "auto",
      }}
    >
      <Container />
      
      {(!container || container.length < 3) && (
        <Grid item xs={12} sx={{ margin: "0px 20px 30px 20px" }}>
          <Alert
            type="error"
            message="Número de Contenedor Requerido"
            showIcon
            closable={false}
            style={{ width: "100%" }}
          />
        </Grid>
      )}
      
      <Grid item xs={12} sx={{ margin: "0px 20px 5px 20px" }}>
        <Segmented
          options={["Seleccionar", "Grabar"]}
          value={value}
          onChange={handleChangeValue}
          block
          size="large"
        />
      </Grid>
      
      {value === "Seleccionar" ? (
        <>
          <Grid
            item
            xs={12}
            sm={10}
            md={8}
            lg={6}
            xl={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <VideoCajas />
             <VideoCierreContenedor />
          </Grid>

         
        </>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            justifyContent: "center",
            alignItems: "center",
            margin: "0px 0px 10px 0px",
          }}
        >
          <VideoCajasRecorder />
          <VideoCierreRecorder />
        </div>
      )}

      <Grid item xs={12} sx={{ margin: "20px 20px" }}>
        <Alert
          type="error"
          message={`Si sale del Módulo de Videos, o si cambia a ${
            value === "Grabar" ? "Seleccionar" : "Grabar"
          }, se borrará ${
            value === "Grabar" ? "lo grabado" : "lo seleccionado"
          }`}
          showIcon
          closable={false}
          style={{ width: "100%", fontWeight: "bold" }}
        />
      </Grid>
    </Grid>
  );
};

const Container = () => {
  const container = useVideoStore((state) => state.container);
  const setContainer = useVideoStore((state) => state.setContainer);

  const renderContenedorInput = React.useMemo(() => {
    return (
      <Input
        value={container || ""}
        onChange={(e) => setContainer(e.target.value.toUpperCase())}
        addonBefore="CONTENEDOR"
        size="large"
        style={{ width: "100%" }}
        allowClear
      />
    );
  }, [container, setContainer]);

  return (
    <Grid item xs={12} sx={{ margin: "0px 20px 5px 20px" }}>
      {renderContenedorInput}
    </Grid>
  );
};

export default VideoPageComponent;